import React from 'react';
import { Modal } from 'antd';
import { useFormContext } from 'react-hook-form';
import { AlertSuccess } from '../../../../util/Alert';
import { useQueryClient } from '@tanstack/react-query';
import fitSurveyServices from '../../../../../services/fit-survey.services';
import LegacySurveyQuestionForm from '../form/LegacySurveyQuestionForm';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

const LegacySurveyQuestionModal = ({ open, handleClose }) => {
  const { watch, handleSubmit } = useFormContext();
  const queryClient = useQueryClient();
  const params = useParams();

  const { mutate: createLegacySurveyQuestion } =
    fitSurveyServices.useMutationCreateLegacySurveyQuestion(() => {
      queryClient.invalidateQueries({
        queryKey: ['get-legacy-survey-question'],
        refetchType: 'all',
      });
      AlertSuccess('เพิ่มข้อมูลสำเร็จ');
      handleClose();
    });

  const { mutate: editLegacySurveyQuestion } =
    fitSurveyServices.useMutationUpdateLegacySurveyQuestion(() => {
      queryClient.invalidateQueries({
        queryKey: ['get-legacy-survey-question'],
        refetchType: 'all',
      });
      AlertSuccess('แก้ไขข้อมูลสำเร็จ');
      handleClose();
    });

  const _HandleSubmit = handleSubmit((data) => {
    const legaySurveyQuestionData = {
      imageUrl: data.imageUrl,
      question: data.question,
      answers: data.answers,
      display: true,
      type: data.type,
      surveyId: params.surveyId,
      required: data.required,
    };

    if (watch('formType') === 'create') {
      createLegacySurveyQuestion(legaySurveyQuestionData);
    } else if (watch('formType') === 'edit') {
      editLegacySurveyQuestion({ id: data.id, data: legaySurveyQuestionData });
    }
  });

  return (
    <Modal
      title={
        watch('formType') === 'create'
          ? 'เพิ่มหมวดแบบสอบถาม'
          : 'แก้ไขหมวดแบบสอบถาม'
      }
      visible={open}
      onCancel={handleClose}
      okText="บันทึก"
      cancelText="ยกเลิก"
      onOk={_HandleSubmit}
      width={'50vw'}
    >
      <LegacySurveyQuestionForm />
    </Modal>
  );
};

export default LegacySurveyQuestionModal;
